import {gameTypeKeys, thirdStore} from "../stores/third";

export const gameSec = 'https://www2.854819.com:42666';

export const LOTTO_CATE = {
    1: ['ssc', '时时彩'],
    2: ['115', '11选5'],
    3: ['3d', '低频彩'],
    13: ['p35', '体彩'],
    15: ['k3', '快3'],
    19: ['pk10', 'PK10'],
};


export const PLATFORM = {
    ALL: 'all',
    HTML5: 'html5',
    HTML5_DESKTOP: 'html5-desktop',
};
export const CLIENT_TYPE = {
    PC: 'pc',
    PHONE: 'phone',
    WEB: 'web',
    HTML5: 'html5',
    ALL: 'all'
};
export const STATUS = {
    CHASE: ['进行中', '已完成', '用户终止', '管理员终止', '系统终止'],
    BET: ['待开奖', '已撤销', '未中奖', '已中奖', '已派奖', '系统撤销'],
    THIRD: ['未结', '中奖', '未中奖', '合', '退回', '半赢', '半输', '提前兑换'],
    FOUND: ['未处理', '申请成功', '申请失败', '充值成功', '加币失败', '充值失败'],
    CHANNEL: ['', '网银', '快捷', '银联扫码', '微信', 'QQ钱包', '京东钱包', '微信'],
    FOUND_CATE: ["所有类型", "在线充值", "提取现金", "转账转入", "转账转出",
        "追号冻结", "投注解冻", "加入游戏", "撤单返款", "提现审核", "提现解冻",
        "派发奖金", "撤销派奖", "派发返点", "撤销返点", "追号返款", "充值费用返还",
        "充值手续费", "人工充值", "管理员提现", "分红", "撤销分红", "理赔充值",
        "促销派奖-彩票", "促销派奖-充值", "促销派奖-消费", "促销派奖-亏损",
        "违规加币", "投注返点", "保底冻结", "合买提成", "保底解冻", "促销派奖-电游",
        "促销派奖-体育", "奖金超限", "礼金充值", "人工充值-掉单", "活动促销",
        "日工资", "投注冻结", "投注确认", "注单返款", "分红转出",
        "Game-transfer-in", "Game-transfer-out"]
}

export const LAUNCH_CONFIG = {
    pvp: {
        15: ['KY0001', 'pvp-0', '开元棋牌'],
        23: ['YB0001', 'pvp-1', 'OB棋牌'],
        33: [0, 'pvp-3'],
    },
    fish: {
        4: ['G00009', 'd0', '', 'html5,html5-desktop'],
        2: ['HMPL', 'd3', '', 'html5'],
        25: ['7003', 'd4', '', 'html5,html5-desktop'],
    },
    sport: {
        14: ['IBC066', 'bs', '沙巴体育', 'html5,html5-desktop'],
        16: ['AV0019', 'bti', '泛亚电竞', 'html5,html5-desktop'],
        18: ['ALB002', 'alb', '188体育', 'html5'],
        19: ['BTI001', 'bt', 'BT体育', 'html5,html5-desktop', 1],
        24: ['esportsbull', 'im', 'IM电竞', 'html5,html5-desktop'],
        28: ['IMSB51', 'im', 'IM电竞', 'html5,html5-desktop'],
        27: ['lh', 'lh', '雷火电竞', 'html5,flash,html5-desktop', 1],
        26: ['ob', 'ob', 'OB电竞', 'html5,flash,html5-desktop', 1],
        30: ['ob', 'ob', 'BT体育', 'html5,flash,html5-desktop', 1],
    },
    live: {
        3: ['M00655', 'a3', '', 'html5-desktop'],
        2: ['A00070', 'a0', '', 'html5,html5-desktop'],
        5: ['BB1001', 'a1', '', 'html5,html5-desktop'],
        7: ['EA0001', 'a2', 'EA娱乐', 'html5'],
        17: ['SEX001', 'a4', 'Sexy Gaming', 'html5,html5-desktop'],
        20: ['EG0001', 'a6', 'E-Gaming', 'html5,html5-desktop'],
        22: ['YB0001', 'a7', '', 'html5,html5-desktop'],
        32: ['ALB001', 'a8', '欧博', 'html5,html5-desktop']
    }
};

export const gameName = (a, b, c) => {
    const cf = thirdStore.game(c, a) || {}
    return cf.name || b[a]
}

export const gameCfg = (cd, pid) => {
    const a = gameTypeKeys.map(k => thirdStore[k])
        .filter(a => a && a.length)
        .reduce((a, b) => a.concat(b), [])
        .find(({code, id}) => code === cd &&(!pid||( +pid === id)))
    if (a) return {
        product_type: a.id,
        game_mode: 1,
        game_code: a.code,
        platform: a.platform
    }
    return {}
}
export const GAME_SUBTYPE = [
    [undefined, '累计奖池'],
    ['SM', '老虎机'],
    ['VP', '视频扑克'],
    ['TG', '桌面游戏'],
    ['SC', '刮刮乐'],
    ['AC', '游戏竞技'],
    ['ROTATE', '再次旋转'],
];


export const COMMISSION_TYPES = {
    lottery: 1,  //彩票
    sport: 2,  //体育
    live: 3,  //真人
    rng: 4,  //老虎机
    pvp: 5,  //棋牌
    fish: 6  //捕鱼
};

export const ROTATE_RNG = {
    3: [
        /比基尼派对/, /舞龙/,
        /刺青酒店/, /宝石之轮/,
        /经典老虎机/, /钻石浮华/,
        /东方珍兽/, /酷热经典/,
        /OZ之书/i, /好运经纪人/,
        /再抢银行在旋转/, /之书锁定并旋转/, /幸运富豪/],
    11: [
        /跳更高/, /飞起来/, /金鸡报囍2/,
        /直式跳更高/, /金鸡报囍([3三])/,
        /直式金鸡报囍([2二])/, /转珠猪/],
    6: [/宝石财富/, /美杜莎的诅咒/]
}
export const WALLETS = {
    22: 'OB真人',
    23: 'OB棋牌',
    21: '盘口彩票',
    19: 'BT体育',
}
